export default __webpack_public_path__ + "static/media/project-kulkarni-law-firm.82acc0d6.png";